import { render, staticRenderFns } from "./SimpleDialog.vue?vue&type=template&id=41fc15ae"
import script from "./SimpleDialog.vue?vue&type=script&lang=js"
export * from "./SimpleDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports